import svFontIcon from './sv-font-icon.vue'
export default svFontIcon